<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>Editing Ranking Name</h4>
    <button mat-button [mat-dialog-close]="" (click)="close()" cdkFocusInitial>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content [formGroup]="myGroup">
    <mat-form-field class="full-width" mat-focused>
      <mat-label>Rank Name: </mat-label>
      <input
        matInput
        formControlName="rankingNameFormControl"
        cdkFocusInitial
      />
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <div>
      <button mat-button (click)="close()" class="button-close" cdkFocusInitial>
        Cancel
      </button>
      <button
        mat-button
        [disabled]="!myGroup.valid"
        (click)="onUpdateRankingName()"
        class="button-close"
      >
        Save
      </button>
    </div>
  </div>
</div>
